import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({name: 'anzeigefrist'})
export class AnzeigePipe implements PipeTransform {
  transform(strUEDate: string, args: string[]): any {
    if (!strUEDate) return strUEDate;
    let anzeigeDate = moment(strUEDate);
    anzeigeDate.add(90, 'days');
    //return "";
    return anzeigeDate.diff(moment(), 'days');

  }
}


// WEBPACK FOOTER //
// ./src/pages/ue-list/anzeige-pipe.ts